module.exports = __webpack_public_path__ + "media/images/pic/anime/librarian-7f98c10876d495a8b941a4d8ec0d2718.svg";